<template>
  <div class="main">
    <img
      class="home-bg"
      :src="
        'https://image-hast.huian365.com/prd/2024-03-13/huian/1710293346946.jpg?' +
        new Date().getTime()
      "
      alt=""
    />
    <!-- 'https://ycss-txkd.oss-cn-beijing.aliyuncs.com/index.jpg?' + -->
    <!-- https://zsh-public.oss-cn-beijing.aliyuncs.com/qianxihezhaopin/homeBg.png -->
    <div class="button" @click="goJobList">开始投递</div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  methods: {
    goJobList() {
      console.log('ss')
      this.$router.push({ name: 'jobList' })
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100vw;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  .home-bg {
    width: 100%;
  }
  .button {
    width: 323px;
    height: 49px;
    background: #b7ffec;
    border-radius: 5px;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 60px;
    animation-name: move;
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
}

@keyframes move {
  0% {
    transform: scale(1.05);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1.05);
  }
}
</style>
